/**
 *  The purpose of this method is to check if
 *  a language has changed or not
 *
 *  @returns Boolean - true indicates it as changed
 */

import { Language } from '~/services/CandidateService';

export default function hasLangChanged(language: Language, oldLanguages: Language[] = []) {
    if (!language.id) return true;

    const oldLang = oldLanguages.find(l => l.id === language.id);
    if (!oldLang) return false;

    return (
        language.languageId !== oldLang.languageId ||
        language.proficiencyId !== oldLang.proficiencyId
    );
}
